module.exports = __webpack_public_path__ + "img/Sign_365.6d444af3.png";